export default "__VITE_ASSET__BrLcado9__"